import { TransactionCategory } from './transaction';

export enum ActivityError {
  NO_ACTIVITY_FOUND = 'NO_ACTIVITY_FOUND',
  GENERIC_ERROR = 'GENERIC_ERROR',
}

export enum ActivityCashFlowError {
  NO_CASHFLOW_FOUND = 'NO_CASHFLOW_FOUND',
  GENERIC_ERROR = 'GENERIC_ERROR',
}

export enum CategoryStatus {
  EXPIRED = 'EXPIRED',
  NEW = 'NEW',
}

export enum ActivityEntryType {
  FOLDER_SHARE = 'FOLDER_SHARE',
  RECATEGORISATION = 'RECATEGORISATION',
}

export interface PartnerData {
  partnerName: string;
  createdAt: string;
}

export interface RecategorisationData {
  cashFlowId: string;
  analysisId: string;
  labelRoot: string;
  oldCategory: TransactionCategory;
  newCategory: TransactionCategory;
  status: CategoryStatus;
  createdAt: string;
}

export interface ActivityEntry {
  type: ActivityEntryType;
  userName: string;
  customIdentifier: string;
  partnerData?: PartnerData[];
  createdAt: string;
  recategorisationData?: RecategorisationData[];
  organizationId: string;
  projectId: string;
  customerId: string;
}

export interface ActivityEntryByDate {
  date: string;
  activity: ActivityEntry[];
}
